<script lang="ts">
  import { projectToplists } from "$lib/services/store.js";
  import Group from "$lib/admin/components/Group.svelte";
  import Input from "$lib/admin/components/Input.svelte";

  export let props = null;

  const id = Math.random().toString(16);
</script>

<Group colspan="4-8" addClass="form-item">
  <Input type="select" label="Toplist data" id={`data-${id}`} bind:value={props.toplistId}>
    {#if $projectToplists}
      <option value={null}>None</option>
      {#each $projectToplists as item}
        <option value={item.id}>{item.name}</option>
      {/each}
    {/if}
  </Input>
</Group>
